import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { id: "account" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "column" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "column" }
const _hoisted_6 = { class: "row center-align" }
const _hoisted_7 = {
  key: 0,
  class: "center-align loading"
}
const _hoisted_8 = {
  key: 1,
  class: "center-align setup"
}
const _hoisted_9 = {
  key: 2,
  class: "center-align not-set"
}
const _hoisted_10 = { class: "row no-wrap" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = { id: "quickbooks-popup" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[0] || (_cache[0] = _createElementVNode("h3", { class: "header-6" }, "General Settings", -1)),
        _createElementVNode("button", {
          class: "caps primary",
          onClick: $setup.doLogout,
          disabled: $setup.loggingOut
        }, "Logout", 8, _hoisted_4)
      ]),
      _cache[7] || (_cache[7] = _createElementVNode("div", { class: "divider" }, null, -1)),
      _createElementVNode("div", _hoisted_5, [
        _cache[6] || (_cache[6] = _createElementVNode("h3", { class: "header-6" }, "Quickbooks Settings", -1)),
        _createElementVNode("div", _hoisted_6, [
          _cache[4] || (_cache[4] = _createElementVNode("h5", { class: "subheader" }, "Status", -1)),
          ($setup.isLoading)
            ? (_openBlock(), _createElementBlock("span", _hoisted_7, _cache[1] || (_cache[1] = [
                _createElementVNode("span", { class: "box" }, [
                  _createElementVNode("svg", {
                    class: "icon svg check-box empty",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg"
                  }, [
                    _createElementVNode("path", {
                      class: "path filled",
                      d: "M19 5V19H5V5H19ZM19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3Z"
                    })
                  ])
                ], -1),
                _createElementVNode("span", null, "Loading...", -1)
              ])))
            : ($setup.isSetup)
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, _cache[2] || (_cache[2] = [
                  _createElementVNode("span", { class: "box" }, [
                    _createElementVNode("svg", {
                      class: "icon svg check-box checked",
                      width: "24",
                      height: "24",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg"
                    }, [
                      _createElementVNode("path", {
                        class: "path filled",
                        d: "M19 3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.11 21 21 20.1 21 19V5C21 3.9 20.11 3 19 3ZM10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z",
                        fill: "#0B8043"
                      })
                    ])
                  ], -1),
                  _createElementVNode("span", null, "Connected", -1)
                ])))
              : (_openBlock(), _createElementBlock("span", _hoisted_9, _cache[3] || (_cache[3] = [
                  _createElementVNode("span", { class: "box" }, [
                    _createElementVNode("svg", {
                      class: "icon svg check-box null",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg"
                    }, [
                      _createElementVNode("path", {
                        class: "path filled",
                        d: "M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM17 13H7V11H17V13Z"
                      })
                    ])
                  ], -1),
                  _createElementVNode("span", null, "Not Connected", -1)
                ])))
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("button", {
            class: "caps secondary",
            onClick: $setup.doQuickbooks,
            disabled: $setup.isLoading
          }, [
            ($setup.isLoading)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode("Loading...")
                ], 64))
              : ($setup.isSetup)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode("Connect Again")
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createTextVNode("Connect Quickbooks")
                  ], 64))
          ], 8, _hoisted_11),
          _cache[5] || (_cache[5] = _createElementVNode("span", { class: "info" }, [
            _createElementVNode("span", null, [
              _createElementVNode("svg", {
                class: "icon filled help question",
                width: "24",
                height: "25",
                viewBox: "0 0 24 25",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg"
              }, [
                _createElementVNode("path", {
                  class: "path filled",
                  d: "M12 2.5C6.48 2.5 2 6.98 2 12.5C2 18.02 6.48 22.5 12 22.5C17.52 22.5 22 18.02 22 12.5C22 6.98 17.52 2.5 12 2.5ZM13 19.5H11V17.5H13V19.5ZM15.07 11.75L14.17 12.67C13.67 13.18 13.31 13.64 13.13 14.36C13.05 14.68 13 15.04 13 15.5H11V15C11 14.54 11.08 14.1 11.22 13.69C11.42 13.11 11.75 12.59 12.17 12.17L13.41 10.91C13.87 10.47 14.09 9.81 13.96 9.11C13.83 8.39 13.27 7.78 12.57 7.58C11.46 7.27 10.43 7.9 10.1 8.85C9.98 9.22 9.67 9.5 9.28 9.5H8.98C8.4 9.5 8 8.94 8.16 8.38C8.59 6.91 9.84 5.79 11.39 5.55C12.91 5.31 14.36 6.1 15.26 7.35C16.44 8.98 16.09 10.73 15.07 11.75V11.75Z"
                })
              ])
            ]),
            _createElementVNode("div", { class: "info-box" }, [
              _createElementVNode("p", null, "Quickbooks Account authorization token will expire after 100 days."),
              _createElementVNode("p", null, "Use of the Managment Portal enables the auth token to refresh automatically."),
              _createElementVNode("p", null, "The account can also be mannually refreshed using the \"Connect\" button.")
            ])
          ], -1))
        ])
      ])
    ]),
    ($setup.waiting)
      ? (_openBlock(), _createBlock($setup["Modal"], { key: 0 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_12, _toDisplayString($setup.message), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}